import { render, staticRenderFns } from "./FeedbackChatsTable.vue?vue&type=template&id=f239199a&"
import script from "./FeedbackChatsTable.vue?vue&type=script&lang=ts&"
export * from "./FeedbackChatsTable.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackChatsTable.vue?vue&type=style&index=0&id=f239199a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports